import { extend } from 'vee-validate';
import { required, digits, email, alpha, length, required_if, regex } from 'vee-validate/dist/rules';
import i18n from '../i18n'

const ibantools = require('ibantools')

extend('required', {
    ...required,
    message: () => i18n.t('validations.required')
});

extend('digits', {
    ...digits,
    message: (field, rule) => i18n.t('validations.digits', { field, length: rule.length })
});

extend('length', {
    ...length,
    message: (field, rule) => `${field}, ${rule.length} uzunluğunda olmalı`
});

extend('minCharacter', (value, params) => {
    if(params[0] > value.length) {
      return i18n.t('validations.minCharacter', {min: params[0]})
    }else{
      return true
    }
  })

extend('email', {
    ...email,
    message: (field) => i18n.t('validations.email', { field })
});

extend('alpha', {
    ...alpha,
    message: (field) => i18n.t('validations.alpha', { field })
});

extend('regex', {
    ...regex,
    message: (field) => i18n.t('validations.regex', { field })
});

extend('phoneNumber', {
    validate: (value) => {
        if (value.length == 13 && value.match(/^[+\d]?(?:[\d-.()]*)$/)) return true
        else return false
    },
    message: (_, values) => i18n.t('validations.phoneNumber', values)
});

extend('tcNumber', {
    validate: (value) => {
        value = value.toString();
        var isEleven = /^[0-9]{11}$/.test(value);
        var totalX = 0;
        for (let i = 0; i < 10; i++) {
            totalX += Number(value.substr(i, 1));
        }
        var isRuleX = totalX % 10 == value.substr(10, 1);
        var totalY1 = 0;
        var totalY2 = 0;
        for (let i = 0; i < 10; i += 2) {
            totalY1 += Number(value.substr(i, 1));
        }
        for (let i = 1; i < 10; i += 2) {
            totalY2 += Number(value.substr(i, 1));
        }
        var isRuleY = ((totalY1 * 7) - totalY2) % 10 == value.substr(9, 0);
        return isEleven && isRuleX && isRuleY;
    },
    message: i18n.t('validations.tcNumber')
})

extend('iban', {
    validate: (value, [country]) => {
        value = value.replace(/\s/g, '');
        if (country) {
            let bban = value.slice(4);
            return ibantools.isValidBBAN(bban, country);
        }
        return ibantools.isValidIBAN(value);
    },
    message: i18n.t('validations.iban')

})

extend('isValid', {
    validate: async (value, [field]) => {
        const input = document.querySelector(`#${field}`)
        if (input) {
            return input.checked
        } else return false
    },
    message: (field, rule) => {
        return i18n.t('validation.isValid', rule[0])
    }

})

extend('required_if', {
    ...required_if,
    message: i18n.t('validations.required')
});